/* Gemelo Jewellers theme script */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  // Header shadow on scroll
  var hdr = $('.site-header');
  if (hdr) { var onScroll = function () { hdr.classList.toggle('is-scrolled', window.scrollY > 8); }; window.addEventListener('scroll', onScroll, { passive: true }); onScroll(); }

  // Mobile drawer
  var drawer = $('#mobile-drawer'), toggle = $('[data-open-drawer]');
  function openDrawer() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); toggle.setAttribute('aria-expanded', 'true'); document.body.classList.add('is-locked'); }
  function closeDrawer() { if (!drawer || !drawer.classList.contains('is-open')) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); toggle.setAttribute('aria-expanded', 'false'); document.body.classList.remove('is-locked'); }
  if (toggle && drawer) toggle.addEventListener('click', openDrawer);
  $$('[data-close-drawer]').forEach(function (b) { b.addEventListener('click', closeDrawer); });

  // Search panel
  var panel = $('.search-panel'), scrim = $('.search-scrim');
  function openSearch() { panel.classList.add('is-open'); scrim.classList.add('is-open'); setTimeout(function () { var i = $('input', panel); if (i) i.focus(); }, 60); }
  function closeSearch() { if (panel) { panel.classList.remove('is-open'); scrim.classList.remove('is-open'); } }
  $$('[data-open-search]').forEach(function (b) { b.addEventListener('click', openSearch); });
  $$('[data-close-search]').forEach(function (b) { b.addEventListener('click', closeSearch); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closeSearch(); } });

  // Quantity steppers
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-step]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var min = parseInt(input.min || '0', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.step, 10));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Cart: submit when a quantity changes
  var cartForm = $('#cart-form');
  if (cartForm) cartForm.addEventListener('change', function (e) { if (e.target.name === 'updates[]') cartForm.submit(); });

  // Collection sort
  var sort = $('#sort-by');
  if (sort) sort.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u.toString(); });
  var style = $('#style-filter');
  if (style) style.addEventListener('change', function () { if (style.value) location.href = style.value; });

  // Product gallery thumbnails + lightbox
  $$('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      var main = $('#pdp-img'); if (!main) return;
      main.src = t.dataset.thumb; main.srcset = '';
      $$('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === t); });
    });
  });
  var zoom = $('[data-zoom]');
  if (zoom) zoom.addEventListener('click', function () {
    var img = $('#pdp-img'); if (!img) return;
    var lb = document.createElement('div'); lb.className = 'lightbox';
    lb.innerHTML = '<img src="' + img.currentSrc + '" alt=""><button class="icon-btn" type="button" aria-label="Close">×</button>';
    lb.addEventListener('click', function () { lb.remove(); document.body.classList.remove('is-locked'); });
    document.body.appendChild(lb); document.body.classList.add('is-locked');
  });

  // Hero: tone picker filters the carousel; tapping a tile swaps the main watch
  $$('[data-hero]').forEach(function (root) {
    var track = $('.hc-track', root), frame = $('[data-hero-frame]', root), cap = $('[data-hero-cap]', root);
    if (!track) return;
    function show(tile) {
      if (!tile || !frame) return;
      var big = $('template[data-big]', tile);
      var html = '<a href="' + tile.dataset.url + '">' + (big ? big.innerHTML : '') + '</a>';
      var old = $('img, svg', frame); if (old) old.classList.add('is-swapping');
      setTimeout(function () { frame.innerHTML = html; }, 200);
      if (cap) cap.innerHTML = '<a href="' + tile.dataset.url + '"><strong>' + tile.dataset.title + '</strong>' + tile.dataset.price + '</a>';
      $$('.hc-tile', track).forEach(function (t) { t.setAttribute('aria-pressed', t === tile); });
    }
    function filter(tone, swap) {
      var tiles = $$('.hc-tile', track), first = null;
      tiles.forEach(function (t) { var ok = (t.dataset.tags || '').indexOf('|' + tone + '|') > -1; t.hidden = !ok; if (ok && !first) first = t; });
      if (!first) tiles.forEach(function (t) { t.hidden = false; });
      track.scrollLeft = 0;
      if (swap && first) show(first);
    }
    $$('.tone-options input', root).forEach(function (r) { r.addEventListener('change', function () { filter(r.value, true); }); });
    track.addEventListener('click', function (e) { var t = e.target.closest('.hc-tile'); if (t) show(t); });
    $$('[data-hc]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var tile = $('.hc-tile:not([hidden])', track);
        track.scrollBy({ left: parseInt(b.dataset.hc, 10) * (tile ? tile.getBoundingClientRect().width + 16 : 200), behavior: 'smooth' });
      });
    });
    var checked = $('.tone-options input:checked', root);
    if (checked) filter(checked.value, false);
  });

  // Add to cart without leaving the page: toast + cart count bump
  var toast = $('[data-toast]'), toastTimer;
  function bumpCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n; el.hidden = n === 0;
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    });
  }
  function showToast(item) {
    if (!toast) return;
    var img = item.image ? '<img src="' + item.image + '" alt="">' : '<span></span>';
    toast.innerHTML = img + '<div><p>Added to your cart</p><strong>' + item.product_title + '</strong>' +
      '<div class="toast-links"><a class="text-link" href="' + window.Gemelo.routes.cart + '">View cart</a><a class="text-link" href="/checkout">Checkout</a></div></div>' +
      '<button class="icon-btn toast-close" type="button" aria-label="Dismiss">×</button>';
    toast.classList.add('is-visible');
    $('.toast-close', toast).addEventListener('click', function () { toast.classList.remove('is-visible'); });
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 5000);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!window.Gemelo || !window.Gemelo.ajaxCart || !form.matches('[data-ajax-add]')) return;
    if (e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]'); if (btn) btn.disabled = true;
    fetch(window.Gemelo.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (item) {
        showToast(item);
        return fetch(window.Gemelo.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) { bumpCount(c.item_count); });
      })
      .catch(function (err) { alert((err && (err.description || err.message)) || 'Could not add to cart. Please try again.'); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  // Related watches (Shopify product recommendations)
  $$('[data-recommendations]').forEach(function (el) {
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });
})();
